import React, { Component } from "react";
import PropTypes from "prop-types";
import Heading from "~/scripts/components/Heading";
import BodyCopy from "~/scripts/components/BodyCopy";

class BrowserUpgrade extends Component {
    static propTypes = {
        onMount: PropTypes.func
    };

    componentDidMount() {
        const { onMount } = this.props;

        if (onMount) {
            onMount();
        }
    }

    render() {
        return (
            <div className="page-wrapper">
                <div className="browser-upgrade">
                    <Heading>Time for an upgrade.</Heading>
                    <BodyCopy>
                        Head to{" "}
                        <a
                            href="http://outdatedbrowser.com/"
                            rel="noreferrer noopener"
                            target="_blank"
                        >
                            this site
                        </a>{" "}
                        for a newer browser version and come back to us.
                    </BodyCopy>
                </div>
            </div>
        );
    }
}

export default BrowserUpgrade;



// WEBPACK FOOTER //
// ./src/scripts/components/pages/BrowserUpgrade.js